module.exports = __webpack_public_path__ + "static/media/id4.890d65d8.png";